import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/authGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';

const PREFIX_AIOPS = 'aiops_';
const aiopsMenu: RouteRecordRaw[] = [
  {
    path: '/aiops/',
    name: `${PREFIX_AIOPS}AIOps`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_AIOPS,
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    redirect: '/aiops/dashboard',
    children: [
      {
        path: 'dashboard',
        name: `${PREFIX_AIOPS}Dashboard`,
        component: () => import('../views/dashboard/AiOpsDashboardView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_AIOPS,
          viewport: VIEWPORT_TYPE.REALTIME,
        },
      },
    ],
  },
];

const getAiopsNaviMenu = () => {
  return extractAccessibleRoutes(aiopsMenu);
};

export { aiopsMenu, getAiopsNaviMenu };
